import Modal from '@/src/components/Antd/Modal/Modal';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import React, { ReactNode, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import Info from './StockInfo/StockInfo';
import ProductSelection from './StockProductSelection/StockProductSelection';
import BulkStockImport from './BulkStockImport';

// import {

// } from './redux';
import { store } from 'src/store';

import Warning from '@/src/components/Antd/Modal/WarningModal';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  emptyData,
  fetchStock,
  fetchStockDetail,
  getSubmitStock,
  submitStock,
  validate,
  getProducts,
} from './slice';

interface IParams {
  uuid: string;
}

const ProductEditor = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [discardModal, setDiscardModal] = React.useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [showBulkImportModal, setShowBulkImportModal] =
    useState<boolean>(false);
  const dispatch = useDispatch();
  const params: IParams = useParams();
  const [modalContent, setModalContent] = useState<ReactNode>('');
  const stockProducts = useSelector(getProducts());

  const { uuid } = params;

  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/productsList',
      name: getI18n('general.allProducts'),
    },
    {
      url: '',

      name: uuid
        ? getI18n('stockIn.stock.detail_general_breadcrumbData_stockindetails')
        : getI18n('stockIn.stock.detail_general_breadcrumbData_addstock'),
    },
  ];

  React.useEffect(() => {
    dispatch(fetchStock());
    if (uuid) {
      dispatch(fetchStockDetail(uuid));
    }
    return () => {
      dispatch(emptyData());
    };
  }, []);

  const onModalCancel = () => {
    setShowModal(false);
  };

  const onBulkImportCancel = () => {
    setShowBulkImportModal(false);
  };

  const openBulkImport = () => {
    setShowBulkImportModal(true);
  };

  const getStock = () => {
    dispatch(validate()); //validation
    const _s = store.getState();
    const stock = getSubmitStock()(_s);
    return stock;
  };
  const onSubmit = () => {
    const data = getStock();
    const { dataValid } = data;
    if (dataValid) {
      dispatch(submitStock(data));
    }
  };
  const hasModified = useSelector((state: any) => state.stock.hasModified);
  const history = useHistory();
  const onDiscard = () => {
    setDiscardModal(true);
  };
  const topRight = (
    <TopLeft
      goBack={() => {
        history.goBack();
      }}
      breadcrumbData={breadcrumbData}
    />
  );

  const topLeft = (
    <TopRight
      onSubmit={onSubmit}
      onSaveDisable={!hasModified}
      onDiscard={onDiscard}
    />
  );
  const Child = [
    {
      child: (
        <Info
          title={
            uuid
              ? getI18n(
                  'stockIn.stock.detail_general_breadcrumbData_stockindetails',
                )
              : getI18n('stockIn.stock.detail_general_breadcrumbData_addstock')
          }
          disabled={uuid ? true : false}
          setShowModal={setShowModal}
          setModalTitle={setModalTitle}
          setModalContent={setModalContent}
        />
      ),
    },
    {
      child: (
        <ProductSelection
          disabled={uuid ? true : false}
          onBulkImport={openBulkImport}
        />
      ),
    },
  ];
  const toProductList = () => {
    history.push('/productsList');
  };
  return (
    <React.Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.leave')}
        active={hasModified && !discardModal}
        title={getI18n('general.unsavedchanges')}
        content={getI18n('general.leavePage')}
      />

      <Warning
        header={getI18n('stockIn.stock.detail_general_discard_title')}
        onCancel={() => {
          setDiscardModal(false);
        }}
        cancelText={getI18n('stockIn.stock.detail_general_discard_cancelText')}
        onOk={toProductList}
        okText={getI18n('general.discard')}
        visible={discardModal}
        title={getI18n('general.commonHeader.discard_header')}>
        <span>{getI18n('general.discardChange')}</span>
      </Warning>

      <Layout
        elements={Child}
        topLeft={topRight}
        {...(uuid ? {} : { topRight: topLeft })}
      />

      <Modal
        visible={showModal}
        title={modalTitle}
        onCancel={onModalCancel}
        cancelText={getI18n('general.cancel')}>
        {modalContent}
      </Modal>

      {showBulkImportModal && (
        <BulkStockImport
          visible={showBulkImportModal}
          onCancel={onBulkImportCancel}
          currentProducts={stockProducts}
        />
      )}
    </React.Fragment>
  );
};

export default ProductEditor;
